let endChatFunction = null;

export function registerEndChat(fn) {
    endChatFunction = fn;

    window.endChat = () => {
        if (endChatFunction) {
            endChatFunction();
        }
    };
}

export function unregisterEndChat() {
    endChatFunction = null;
    delete window.endChat;
}
